module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeDropdwon),
      expression: "closeDropdwon"
    }],
    staticClass: "relative"
  }, [_c('div', [_c('button', {
    staticClass: "relative flex items-center focus:outline-none select-none h-full w-full",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_vm._t("button")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "transition-all duration-200 ease-out",
      "leave-active-class": "transition-all duration-750 ease-in",
      "enter-class": "opacity-0 scale-75",
      "enter-to-class": "opacity-100 scale-100",
      "leave-class": "opacity-100 scale-100",
      "leave-to-class": "opacity-0 scale-75"
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "absolute shadow-lg border w-max rounded text-xs bg-white z-50",
    class: _vm.placement === 'right' ? 'right-0' : 'left-0',
    on: {
      "click": function($event) {
        return _vm.closeDropdwon()
      }
    }
  }, [_vm._t("content")], 2) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b08c6a9e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/vDropdown/vDropdown.vue
// module id = 2386
// module chunks = 61